/** Подпись в шапке группового чата: кто набирает сообщение. */
export function formatMessengerGroupTypingLabel(
  typingUserIds: string[],
  resolveDisplayName: (userId: string) => string
): string {
  if (typingUserIds.length === 0) return '';

  const sorted = [...typingUserIds].sort((a, b) =>
    resolveDisplayName(a).localeCompare(resolveDisplayName(b), 'ru', { sensitivity: 'base' })
  );

  const n = sorted.length;
  if (n === 1) {
    return `${resolveDisplayName(sorted[0])} печатает`;
  }
  if (n === 2) {
    return `${resolveDisplayName(sorted[0])}, ${resolveDisplayName(sorted[1])} печатают`;
  }
  const rest = n - 2;
  return `${resolveDisplayName(sorted[0])}, ${resolveDisplayName(sorted[1])} и ещё ${rest} печатают`;
}
